(function($){

// ---------- Header START
$.widget('ans.header', {

	_create: function(){
			this._initNav();
	},

	_initNav: function(){
		var toggler = $('.fs-menu__toggle');
		var menu_items = $('.menu-item');
		
		toggler.on('click', toggleNav);
		menu_items.on('click', closeNav);
		
		function toggleNav(){
			if($('body').hasClass('is-overlayed')) {
				closeNav();
			} else {
				openNav();
			}
		}

		function openNav(){
			$('body').addClass('is-overlayed');
			$(window).on('keyup', listenEscKey);
		}

		function closeNav(){
			$('body').removeClass('is-overlayed');
			$(window).off('keyup', listenEscKey);
		}

		function listenEscKey(e){
			if(e.keyCode === 27) {
				closeNav();
			}
		}
	}

});
// ---------- Header END

})(jQuery);
